export enum RoleView {
    Borrow = "Borrow",
    Lend = "Lend"
}
